import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _SortDownLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "M5 8h8M5 12h6M5 16h4" }),
            React.createElement("path", { stroke: "currentColor", d: "m16 15 3 3 3-3m-3 3V6" })));
}
const SortDownLight = forwardRef(_SortDownLight);
export { SortDownLight };
